var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-instagram" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.instagram.visibility")) +
                " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _vm.pagesSelectedIncludeConciergerie
              ? _c(
                  "div",
                  { staticClass: "type-switch" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "dash.post-creator.form.instagram.share-as-story"
                          )
                        ) +
                        "\n                "
                    ),
                    _c("ComponentSwitch", {
                      attrs: {
                        value:
                          _vm.draftInstance.form.networks.instagram
                            .storification.active,
                        onChange: _vm.handlerSharePostInStory,
                        id: "switch-settings-advanced-instagram-1",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.pagesSelectedIncludeConciergerie
              ? _c(
                  "div",
                  {
                    staticClass: "type-switch",
                    style: {
                      opacity: _vm.draftInstance.form.networks.instagram
                        .storification.active
                        ? 1
                        : 0.6,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "dash.post-creator.form.instagram.share-story-facebook"
                          )
                        ) +
                        "\n                "
                    ),
                    _c("ComponentSwitch", {
                      attrs: {
                        value:
                          _vm.draftInstance.form.networks.instagram
                            .storification.shareInFacebook,
                        onChange: _vm.handlerSharePostInStoryFacebook,
                        isDisable:
                          !_vm.draftInstance.form.networks.instagram
                            .storification.active,
                        id: "switch-settings-advanced-instagram-2",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "list-simple-btn" },
              [
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text:
                        !_vm.nativeMode &&
                        _vm.$t(
                          "dash.post-creator.form.instagram.native-mode-only"
                        ),
                      active: !_vm.nativeMode,
                      position: "bottom",
                      classCustom: `type-btn-simple ${
                        !_vm.nativeMode ? "locked" : ""
                      }`,
                    },
                    on: { click: _vm.openAddIdentifierMode },
                  },
                  [
                    _c("i", { staticClass: "fa-regular fa-circle-user" }),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t(
                              "dash.post-creator.form.instagram.tagged-person"
                            )
                          ) +
                          " \n                        "
                      ),
                      _c("span", { staticClass: "pink" }, [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.draftInstance.form.networks.instagram
                                .personsIdentified.length
                            ) +
                            ")"
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text:
                        !_vm.nativeMode && "Disponible seulement en mode natif",
                      active: !_vm.nativeMode,
                      position: "bottom",
                      classCustom: `
                        type-btn-simple 
                        ${!_vm.nativeMode ? "locked" : ""}`,
                    },
                    on: { click: _vm.openAddCollaboratorMode },
                  },
                  [
                    _c("i", { staticClass: "fa-regular fa-circle-user" }),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t(
                              "dash.post-creator.form.instagram.collaborator"
                            )
                          ) +
                          " \n                        "
                      ),
                      _c("span", { staticClass: "pink" }, [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.draftInstance.form.networks.instagram
                                .collaborators.length || "0"
                            ) +
                            ")"
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.$t(
                        "dash.post-creator.form.instagram.native-mode-only"
                      ),
                      active: !_vm.nativeMode,
                      position: "bottom",
                      classCustom: `type-btn-simple ${
                        !_vm.nativeMode ? "locked" : ""
                      }`,
                    },
                    on: {
                      click: function ($event) {
                        _vm.nativeMode && _vm.addMode("addPlaceMode")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-map-pin" }),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.instagram.place")
                          ) +
                          " \n                        "
                      ),
                      _c("span", { staticClass: "pink" }, [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.draftInstance.form.networks.instagram.place
                                ? "1"
                                : "0"
                            ) +
                            ")"
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.$t(
                        "dash.post-creator.form.instagram.native-mode-only"
                      ),
                      active: !_vm.nativeMode,
                      position: "bottom",
                      classCustom: `type-btn-simple ${
                        !_vm.nativeMode ? "locked" : ""
                      }`,
                    },
                    on: {
                      click: function ($event) {
                        _vm.nativeMode && _vm.addMode("addMusicMode")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-solid fa-music" }),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.instagram.music")
                          ) +
                          " \n                        "
                      ),
                      _c("span", { staticClass: "pink" }, [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.draftInstance.form.networks.instagram.music
                                ? "1"
                                : "0"
                            ) +
                            ")"
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.$t(
                        "dash.post-creator.form.instagram.native-mode-only"
                      ),
                      active: !_vm.nativeMode,
                      position: "bottom",
                      classCustom: `type-btn-simple ${
                        !_vm.nativeMode ? "locked" : ""
                      }`,
                    },
                    on: {
                      click: function ($event) {
                        _vm.nativeMode && _vm.addMode("addProductMode")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa-regular fa-bag-shopping" }),
                    _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t("dash.post-creator.form.instagram.product")
                          ) +
                          " \n                        "
                      ),
                      _c("span", { staticClass: "pink" }, [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.draftInstance.form.networks.instagram.products
                                .length
                            ) +
                            ")"
                        ),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm.showRatio
          ? _c("details", { attrs: { open: "" } }, [
              _c("summary", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("dash.post-creator.form.instagram.format")) +
                    " \n            "
                ),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]),
              _c("div", { staticClass: "content-detail" }, [
                _c(
                  "div",
                  {
                    staticClass: "list-radio-btn",
                    class: { disable: _vm.ratioIsDisable },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "type-btn-simple",
                        on: {
                          click: function ($event) {
                            return _vm.changeRatio("auto")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-circle",
                          class: {
                            "fa-solid fa-circle-dot":
                              _vm.draftInstance.form.networks.instagram.ratio ==
                              "auto",
                          },
                        }),
                        _c("p", [_vm._v("Original")]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "type-btn-simple",
                        on: {
                          click: function ($event) {
                            return _vm.changeRatio("4:5")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-circle",
                          class: {
                            "fa-solid fa-circle-dot":
                              _vm.draftInstance.form.networks.instagram.ratio ==
                              "4:5",
                          },
                        }),
                        _c("p", [_vm._v("Ratio 4:5")]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "type-btn-simple",
                        on: {
                          click: function ($event) {
                            return _vm.changeRatio("1:1")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-circle",
                          class: {
                            "fa-solid fa-circle-dot":
                              !_vm.draftInstance.form.networks.instagram
                                .ratio ||
                              _vm.draftInstance.form.networks.instagram.ratio ==
                                "1:1",
                          },
                        }),
                        _c("p", [_vm._v("Ratio 1:1")]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "type-btn-simple",
                        on: {
                          click: function ($event) {
                            return _vm.changeRatio("16:9")
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-regular fa-circle",
                          class: {
                            "fa-solid fa-circle-dot":
                              _vm.draftInstance.form.networks.instagram.ratio ==
                              "16:9",
                          },
                        }),
                        _c("p", [_vm._v("Ratio 16:9")]),
                      ]
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }